export enum AlertTypeEnum {
	INFO = 'info',
	SUCCESS = 'success',
	WARNING = 'warning',
	ERROR = 'error'
}

export const ALERT_TYPE_ENUM_VALUES = Object.values(AlertTypeEnum);
